module.exports = __webpack_public_path__ + "img/piglet.3bf74ab4.png";